
const app = {
    namespaced: true,

    state: {
        loading: false,
        // Popolato dall'interceptor axios (services/interceptor.js) a ogni
        // risposta di errore: prima veniva solo loggato in console, l'utente
        // non vedeva alcun messaggio (es. eliminazione bloccata da vincoli).
        snackbar: { show: false, text: "", color: "error" },
    },

    mutations: {

        SET_LOADING(state, vis) {
            state.loading = vis
        },

        SHOW_MESSAGE(state, { text, color }) {
            state.snackbar = { show: true, text, color: color || "error" }
        },

        HIDE_MESSAGE(state) {
            state.snackbar.show = false
        },

    },


}

export default app